<template>
  <div>
    <left-pane :data="responseData" :selectedPatient="selectedPatient" @tabChange="tabChange" @selectFromList="selectFromList" />
    <div v-if="responseData.length>0 || status === 'new'" class="flex flex-col overflow-y-auto w-full" style="height: calc(100vh - 3rem)">
      <div class="flex flex-row h-10 bg-grey-extralight flex-no-shrink flex-no-grow border-solid border-b border-grey-lightest">
        <div class="self-center ml-4 text-sm font-semibold text-grey-darkest">COVID-19</div>
      </div>
      <div class="flex flex-row bg-white flex-no-shrink flex-no-grow border-solid border-b border-grey-lighest">
        <div class="flex flex-col flex-no-shrink flex-no-grow px-8 pt-4 pb-8 mr-auto border-r border-solid border-grey-lighest" style="width: 400px">
          <div class="my-4 flex flex-col">
            <label class="text-sm font-semibold text-grey-dark mb-2 tracking-wide" for="prescribe_drug" style="text-transform: uppercase">Name <span class="text-red text-m">*</span></label>
            <input :disabled="status==='done' ? true : false" type="text" v-model="selectedPatient.name" class="h-8 p-2 rounded-sm border border-solid border-grey-lightest bg-grey-extralight text-grey-darkest" style="outline: none" >
          </div>
          <div class="my-4 flex flex-col">
            <label class="text-sm font-semibold text-grey-dark mb-2 tracking-wide" for="prescribe_drug" style="text-transform: uppercase">Email <span class="text-red text-m">*</span></label>
            <input :disabled="status==='done' ? true : false" type="text" v-model="selectedPatient.email" class="h-8 p-2 rounded-sm border border-solid border-grey-lightest bg-grey-extralight text-grey-darkest" style="outline: none" >
          </div>
          <div class="my-4 flex flex-col">
            <label class="text-sm font-semibold text-grey-dark mb-2 tracking-wide" for="prescribe_drug" style="text-transform: uppercase">Mobile Number <span v-if="status === 'new'" class="text-red text-m">*</span></label>
            <input :disabled="status !== 'new' ? true : false" type="number" v-model="selectedPatient.mobile_number" class="h-8 p-2 rounded-sm border border-solid border-grey-lightest bg-grey-extralight text-grey-darkest" style="outline: none" >
          </div>
          <div class="my-4 flex flex-col">
            <label class="text-sm font-semibold text-grey-dark mb-2 tracking-wide" for="prescribe_drug" style="text-transform: uppercase">Age</label>
            <input :disabled="status==='done' ? true : false" min="0" type="number" v-model="selectedPatient.response.age" class="h-8 p-2 rounded-sm border border-solid border-grey-lightest bg-grey-extralight text-grey-darkest" style="outline: none" >
          </div>
          <div class="my-4 flex flex-col">
            <label class="text-sm font-semibold text-grey-dark mb-2 tracking-wide" for="prescribe_drug" style="text-transform: uppercase">Gender</label>
            <div class="flex flex-row">
              <div class="flex flex-row items-center">
                <input :disabled="status==='done' ? true : false" value="male" type="radio" v-model="selectedPatient.response.gender" class="h-8 p-2 rounded-sm border border-solid border-grey-lightest bg-grey-extralight text-grey-darkest" style="outline: none" >
                <label class="text-sm font-semibold text-grey-dark ml-2 tracking-wide" for="prescribe_drug">Male</label>
              </div>
              <div class="flex flex-row items-center ml-4">
                <input :disabled="status==='done' ? true : false" value="female" type="radio" v-model="selectedPatient.response.gender" class="h-8 p-2 rounded-sm border border-solid border-grey-lightest bg-grey-extralight text-grey-darkest" style="outline: none" >
                <label class="text-sm font-semibold text-grey-dark ml-2 tracking-wide" for="prescribe_drug">Female</label>
              </div>
            </div>
          </div>
          <div class="my-4 flex flex-col">
            <label class="text-sm font-semibold text-grey-dark mb-2 tracking-wide" for="prescribe_drug" style="text-transform: uppercase">Address <span class="text-red text-m">*</span></label>
            <textarea :disabled="status==='done' ? true : false" type="text" v-model="selectedPatient.address" class="h-24 p-2 rounded-sm border border-solid border-grey-lightest bg-grey-extralight text-grey-darkest" style="outline: none" ></textarea>
          </div>
          <div class="my-4 flex flex-col">
            <label class="text-sm font-semibold text-grey-dark mb-2 tracking-wide" for="prescribe_drug" style="text-transform: uppercase">Summary <span class="text-red text-m">*</span></label>
            <textarea :disabled="status==='done' ? true : false" type="text" v-model="selectedPatient.summary" class="h-24 p-2 rounded-sm border border-solid border-grey-lightest bg-grey-extralight text-grey-darkest" style="outline: none" ></textarea>
          </div>
          <div class="my-4 flex flex-col">
            <label class="text-sm font-semibold text-grey-dark mb-2 tracking-wide" for="prescribe_drug" style="text-transform: uppercase">Provisional Diagnosis <span class="text-red text-m">*</span></label>
            <textarea :disabled="status==='done' ? true : false" type="text" v-model="selectedPatient.provisional_diagnosis" class="h-24 p-2 rounded-sm border border-solid border-grey-lightest bg-grey-extralight text-grey-darkest" style="outline: none" ></textarea>
          </div>
          <div class="mt-4 flex flex-row">
            <input :disabled="status==='done' ? true : false" type="checkbox" v-model="selectedPatient.sendPrescription" name="drug_duration" class="h-8 p-2 bg-grey-extralight rounded-sm border border-solid border-grey-lightest text-base text-grey-darkest focus:border-blue" style="outline: none">
            <label class="p-2 mr-2 text-sm font-semibold text-grey-dark" style="text-transform: uppercase">Recommend Covid-19 test</label>
          </div>
          <div class="mt-4 flex flex-row">
            <span v-if="status==='done'" class="w-full cursor-not-allowed border border-solid border-green bg-green py-2 px-5 text-white font-semibold text-center rounded self-center flex-no-shrink items-end">Marked as done</span>
            <span v-else @click="markAsDone('done')" class="w-full hover:shadow-md cursor-pointer border border-solid border-blue bg-blue py-2 px-5 text-white font-semibold text-center rounded self-center flex-no-shrink items-end">Mark as done</span>
          </div>
          <div v-if="status!=='done' && status!== 'new'" class="mt-4 flex flex-row">
            <span @click="openPopup()" class="w-full hover:shadow-md cursor-pointer border border-solid border-grey-lightest bg-white py-2 px-auto text-blue font-semibold text-center rounded self-center flex-no-shrink items-end">Customer didn't answer the call</span>
          </div>
        </div>
        <div v-if="selectedPatient.response['0'] || selectedPatient.response['1'] || answer3 || answer4 || answer5"
            class="flex flex-col">
          <!-- <label class="text-sm font-semibold text-grey-dark" style="text-transform: uppercase"> Query Response</label> -->
          <div class="my-4 flex flex-col">
            <!-- <ul> -->
              <div v-if="selectedPatient.response['0']" class="flex flex-row mb-4 px-8 py-4 border-solid border-b border-grey-lighest">
                <div class="felx text-lg font-semibold text-grey mr-2 mt-1">*</div>
                <div class="flex flex-col">
                  <div class="text-base font-semibold text-grey">Have you travelled to any of the high-risk COVID-19 affected countries in the last 14 days?</div>
                  <p class="text-base text-grey-darker font-semibold my-2">{{selectedPatient.response['0']}}</p>
                </div>
              </div>
              <div v-if="selectedPatient.response['1']" class="flex flex-row mb-4 px-8 py-4 border-solid border-b border-grey-lighest">
                <div class="felx text-lg font-semibold text-grey mr-2 mt-1">*</div>
                <div class="flex flex-col">
                  <div class="text-base font-semibold text-grey">Did you come in contact with a laboratory tested positive case or suspected person in the last 14 days?</div>
                  <p class="text-base text-grey-darker font-semibold my-2">{{selectedPatient.response['1']}}</p>
                </div>  
              </div>
              <div v-if="answer3" class="flex flex-row mb-4 px-8 py-4 border-solid border-b border-grey-lighest">
                <div class="felx text-lg font-semibold text-grey mr-2 mt-1">*</div>
                <div class="flex flex-col">
                  <div class="text-base font-semibold text-grey">Have you developed any new symptoms recently? Please select an option from below. </div>
                  <p class="text-base text-grey-darker font-semibold my-2">{{answer3}}</p>
                </div>  
              </div>
              <div v-if="answer4" class="flex flex-row mb-4 px-8 py-4 border-solid border-b border-grey-lighest">
                <div class="felx text-lg font-semibold text-grey mr-2 mt-1">*</div>
                <div class="flex flex-col">
                  <div class="text-base font-semibold text-grey">Any of these signs could also be an indication of infection. Please select an option from below </div>
                  <p class="text-base text-grey-darker font-semibold my-2">{{answer4}}</p>
                </div>  
              </div>
              <div v-if="answer5" class="flex flex-row mb-4 px-8 py-4 border-solid border-b border-grey-lighest">
                <div class="felx text-lg font-semibold text-grey mr-2 mt-1">*</div>
                <div class="flex flex-col">
                  <div class="text-base font-semibold text-grey">Do you have a pre-existing condition or medical history? </div>
                  <p class="text-base text-grey-darker font-semibold my-2">{{answer5}}</p>
                </div>  
              </div>
            <!-- </ul>  -->
          </div>
        </div>
      </div>
    </div>
    <div v-if="showPopup">
      <div id="overlay" @click="closeOverlay()" style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); z-index: 10; cursor: pointer;"></div>
      <div class="absolute flex flex-col bg-white shadow rounded-sm h-auto z-20 py-4 px-2" style="width: 600px; left: calc((100vw - 600px)/2); top:150px;">
          <div class="flex flex-col justify-center px-4 py-2">
              <div class="flex flex-row mb-2 justify-between items-center">
                  <div class="align-center text-lg text-left font-semibold py-2">Confirm</div>
                  <img @click="closeOverlay()" class="w-6 h-6 cursor-pointer" src="../../assets/close.png">
              </div>
              <label class="text-grey-darker my-2 text-base">Please click 'YES' if you have called the customer twice, otherwise click 'NO'. Clicking 'YES' will remove the customer request.</label>
              <div class="flex flex-row mt-4 mb-2 justify-start">
                  <div @click="popupStatus()" class="flex flex-col bg-blue px-6 py-2 justify-center cursor-pointer font-semibold rounded-sm text-white text-sm hover:shadow-md">Yes</div>
                  <div @click="closeOverlay()" class="flex flex-col bg-white px-6 py-2 justify-center cursor-pointer font-semibold rounded-sm text-blue text-sm hover:shadow-md ml-4 border border-solid border-grey-lightest">No</div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftPane from '@/components/COVID-19/LeftPane'
import covidApi from '../../api/covid19'
export default {
  components: {
    LeftPane
  },
  data () {
    return {
      selectedPatient: {
        id: null,
        name: '',
        email: '',
        mobile_number: '',
        response: {
          age: null,
          gender: 'male'
        },
        sendPrescription: false,
        summary: '',
        address: '',
        provisional_diagnosis: ''
      },
      responseData: [],
      selectedTab: 'pending',
      status: null,
      showPopup: false
    }
  },
  computed: {
    answer3: function () {
      if (this.selectedPatient.response['2']) {
        try {
          return JSON.parse(this.selectedPatient.response['2']).join(', ')
        } catch (err) {
          return null
        }
      }
      return null
    },
    answer4: function () {
      if (this.selectedPatient.response['3']) {
        try {
          return JSON.parse(this.selectedPatient.response['3']).join(', ')
        } catch (err) {
          return null
        }
      }
      return null
    },
    answer5: function () {
      if (this.selectedPatient.response['4']) {
        try {
          return JSON.parse(this.selectedPatient.response['4']).join(', ')
        } catch (err) {
          return null
        }
      }
      return null
    }
  },
  mounted () {
    this.getContacts()
  },
  methods: {
    openPopup: function () {
      this.showPopup = true
    },
    closeOverlay: function () {
      this.showPopup = false
    },
    getContacts: function () {
      let that = this
      covidApi.index(this.status).then(response => {
        if (response.status === 200) {
          that.selectedPatient = {
            id: null,
            name: '',
            email: '',
            mobile_number: '',
            response: {
              age: null,
              gender: 'male'
            },
            sendPrescription: false,
            summary: ''
          }
          if (response.body.customer && response.body.customer.length > 0 && that.selectedTab !== 'covid-new') {
            that.responseData = response.body.customer
            that.selectedPatient = response.body.customer[0]
          } else {
            that.responseData = response.body.customer
            that.selectedPatient = {
              id: null,
              name: '',
              email: '',
              mobile_number: '',
              response: {
                age: null,
                gender: 'male'
              }
            }
          }
        }
      })
    },
    tabChange: function (tab) {
      this.selectedTab = tab
      if (this.selectedTab === 'completed') {
        this.status = 'done'
      } else if (this.selectedTab === 'covid-new') {
        this.status = 'new'
        this.selectedPatient = {
          id: null,
          name: '',
          email: '',
          mobile_number: '',
          response: {
            age: null,
            gender: 'male'
          }
        }
      } else {
        this.status = null
      }
      this.getContacts()
    },
    markAsDone: function (status) {
      if (this.selectedPatient.name && this.selectedPatient.name.trim() !== '' && this.selectedPatient.email && this.selectedPatient.email.trim() !== '' && this.selectedPatient.summary && this.selectedPatient.summary.trim() !== '' && this.selectedPatient.address && this.selectedPatient.address.trim() !== '' && this.selectedPatient.provisional_diagnosis && this.selectedPatient.provisional_diagnosis.trim() !== '' && ((this.selectedPatient.mobile_number && this.selectedPatient.mobile_number.trim() !== '') || this.status !== 'new')) {
        let payload = {
          name: this.selectedPatient.name,
          email: this.selectedPatient.email,
          age: this.selectedPatient.response.age,
          gender: this.selectedPatient.response.gender,
          summary: this.selectedPatient.summary,
          provisional_diagnosis: this.selectedPatient.provisional_diagnosis,
          address: this.selectedPatient.address,
          send_prescription: this.selectedPatient.sendPrescription,
          status: status
        }
        if (this.status === 'new') {
          payload['mobile_number'] = this.selectedPatient.mobile_number
          return this.createHandler(payload)
        } else {
          return this.updateStatusHandler(payload)
        }
      } else {
        this.$toast.open({
          message: `Please fill all mandatory fields`,
          type: 'warning',
          position: 'top',
          queue: false
        })
      }
    },
    updateStatusHandler: function (payload) {
      let that = this
      covidApi.update({id: this.selectedPatient.id, params: payload}).then(response => {
        if (response.status === 200) {
          that.getContacts()
        }
      })
    },

    createHandler: function (payload) {
      let _this = this
      covidApi.create({params: payload}).then(response => {
        if (response.status === 200) {
          _this.getContacts()
        }
      })
    },

    popupStatus: function () {
      this.closeOverlay()
      this.updateStatusHandler({status: 'no_answer'})
    },
    selectFromList: function (item) {
      this.selectedPatient = item
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/COVID-19/COVID19.vue